const $mapPlaceholder = $('.js-google-map');

function addMap() {
  if ($mapPlaceholder.length == 0) {
    return
  }

  // Add the googlemaps script
  const api_key = $mapPlaceholder.data('key')
  const googleMapsScript = document.createElement('script');
  const address = $mapPlaceholder.data('address');
  const addressFormatted = encodeURIComponent(address);
  googleMapsScript.type = 'text/javascript';
  googleMapsScript.defer = true;
  googleMapsScript.src = `https://maps.googleapis.com/maps/api/js?key=${api_key}&callback=initMap&libraries=&v=weekly`;

  $('body').append(googleMapsScript)
  

  // Initialize and add the map
  function initMap() {
    // get location latitude and longtitude
    const mapHolder = document.querySelector("#map");
    
    $.ajax({
      url: `https://maps.googleapis.com/maps/api/geocode/json?address=${addressFormatted}&key=${api_key}`,
      type: 'GET',
      dataType: 'json',
    })
    .done(function(data) {
      const location = data.results[0].geometry.location;

      loadMap(mapHolder,location)
    })
    .fail(function() {
      console.log("error");
    })
  }

  // Append the function to the window object
  window.initMap = initMap;
}

addMap();

function loadMap(mapHolder, location) {
// The map, centered at location
  const map = new google.maps.Map(mapHolder, {
    zoom: 17,
    center: location,
  });

  // icon with dimensions
  const icon = {
    url: 'https://cdn.shopify.com/s/files/1/0219/5410/files/Group_157_2x_06e6a540-fac3-4abe-be02-fdf7edadd720.png?v=1606582238',
    scaledSize: new google.maps.Size(39, 48)
  }

  // The marker, positioned at location
  const marker = new google.maps.Marker({
    position: location,
    map: map,
    draggarble: false,
    icon: icon
  });
}